import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import greenHeart from "../assets/greenHeart.svg";
import GetInTouchFooter from "./GetInTouchFooter";
import ViewImageModal from "./custom/ViewImageModal";
import CustomGalleryModal from "./custom/CustomGalleryModal";
import axiosStrapiInstance from "../axiosStrapi";
import { toast } from "react-toastify";
import { baseUrl } from "../axiosStrapi";
import Loader from "./custom/Loader";
import CustomHeading from "./custom/CustomHeading";
import CustomContent from "./custom/CustomContent";
import { headerImages } from "../utils/constants";
import { Helmet } from "react-helmet";

const Dignitories = () => {
  const [viewModal, setViewModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getDigitaries(e) {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/website-images?filters[Type][$eq]=Dignitaries&populate=*"
      );
      setImages(response?.data?.data[0]?.images);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }

  useEffect(() => {
    getDigitaries();
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Esteemed Dignitaries at Mother's Pride - Leaders Who Inspire
        </title>
        <meta
          name="description"
          content="Meet the dignitaries and influential personalities who have visited Mother's Pride, sharing inspiration and supporting early education excellence."
        />
        <meta
          name="keywords"
          content="preschool events, school celebrations, kids' performances, learning through events, annual day"
        />
        <link
          rel="canonical"
          href="https://www.motherspridepreschool.com/dignitory"  
          />
      </Helmet>
      <div>
        <img
          src={
            window.innerWidth < 450
              ? window.innerWidth < 800
                ? headerImages.tabDignitariesHeaderImg
                : headerImages.mobileDignitariesHeaderImg
              : headerImages.dignitariesHeaderImg
          }
          alt="dignitories"
          className="overflow-x-hidden w-[100vw] sm:h-[300px] lg:h-[420px] "
        />
      </div>

      <div className="px-[4%] 2xl:px-[6%] flex flex-col gap-10 ">
        {/* main img */}

        <div className="flex flex-col gap-3 sm:mt-[60px] mt-[20px]">
          <CustomHeading
            text={"Meeting with dignitaries at mother"}
            spanText={"'"}
            spanTextColor="#383838"
            thirdTextColor="#383838"
            secondFontStyle="font-Lato"
            thirdText={window.innerWidth < 950 ? "s Pride" : "s"}
            textSize="60px"
            textColor="#383838"
            customImg={greenHeart}
            heartHeight="40px"
            heartWidth="40px"
            smTextSize="32px"
            heartMarginLeft="20px"
          />
          <div className="flex flex-row items-end gap-1">
            <CustomHeading
              text={"Pride"}
              textSize="60px"
              textColor="#383838"
              smTextSize="32px"
              fontStyle={
                window.innerWidth < 950 ? "hidden" : "block font-Wonderbar"
              }
            />
            <CustomContent
              textColor="#d31c4f"
              text={"//PreSchool"}
              textSize="42px"
              smTextSize="20px"
              leading="52px"
              marginTop={window.innerWidth < 450 ? "-32px" : "0"}
            />
          </div>
          <CustomContent
            textColor="#111010"
            text={
              "Our Little Prideens get to meet eminent personalities and national leaders. They visit the Parliament and have the opportunity to meet the President and the Prime Minister on special occasions like Raksha Bandhan, Independence Day, and Teacher’s Day. These visits help instill confidence in children and encourage self-expression as they interact with today’s leaders."
            }
            textSize="24px"
            leading="38px"
            textAlign="justify"
            smTextSize="18px"
          />
        </div>
        {loading ? (
          <Loader />
        ) : (
          <CustomGalleryModal
            paddingX={"0%"}
            paddingY={"0%"}
            images={images?.map((item) => `${item?.url}`)}
            scroll={true}
            scrollHeight={"90vh"}
          />
        )}

        <GetInTouchFooter marginX={"0%"} />
        {/* Footer */}
        <div>
          <Footer marginX={"0%"} />
        </div>
        {viewModal && (
          <ViewImageModal setOpenModal={setViewModal} url={imageUrl} />
        )}
      </div>
    </div>
  );
};

export default Dignitories;
